<div class="signature-wizard">

  <!-- ============================= -->
  <!-- STEPPER -->
  <!-- ============================= -->

  <div class="wizard-progress">

    <div *ngFor="let tpl of templates; let i = index" class="wizard-step" [ngClass]="{
        'is-active': i === currentStep,
        'is-completed': i < currentStep,
        'is-pending': i > currentStep
      }">

      <!-- Línea entre pasos -->
      <div class="step-line" *ngIf="i < templates.length - 1">
      </div>

      <!-- Indicador -->
      <div class="step-marker">

        <!-- COMPLETADO -->
        <i *ngIf="i < currentStep" class="fa-solid fa-check">
        </i>

        <!-- ACTUAL -->
        <lottie-player *ngIf="i === currentStep" [src]="animation[i]" background="transparent" speed="0.8" loop autoplay
          class="step-animation">
        </lottie-player>

        <!-- PENDIENTE -->
        <ng-container *ngIf="i > currentStep">

          <i *ngIf="icons[i]" [class]="icons[i]">
          </i>

          <span *ngIf="!icons[i]">
            {{ i + 1 }}
          </span>

        </ng-container>

      </div>

      <!-- Nombre -->
      <div class="step-label" *ngIf="!isMobileByWidth()">

        <span *ngIf="nameStepers[i]">
          {{ nameStepers[i] }}
        </span>

        <span *ngIf="!nameStepers[i]">
          Paso {{ i + 1 }}
        </span>

      </div>

    </div>

  </div>


  <!-- ============================= -->
  <!-- CONTENIDO -->
  <!-- ============================= -->

  <div class="wizard-content">

    <div class="wizard-card" [@stepAnimation]>

      <!-- HEADER -->
      <div class="wizard-header" *ngIf="!isMobileByWidth()">

        <div class="header-icon">
          <i class="fa-solid fa-gear"></i>
        </div>

        <div class="header-content">

          <span class="step-eyebrow">
            Paso {{ currentStep + 1 }} de {{ steps }}
          </span>

          <h2>
            {{ titulo_step }}
          </h2>

          <div class="header-description">
            <p>
              Completa los campos y ajusta las opciones de firma.
            </p>

            <p *ngIf="info_step">
              {{ info_step }}
            </p>
          </div>

        </div>

      </div>


      <!-- BODY -->
      <div class="wizard-body">

        <ng-container *ngTemplateOutlet="templates[currentStep]">
        </ng-container>

      </div>


      <!-- FOOTER -->
      <div class="wizard-footer">

        <!-- ANTERIOR -->
        <button type="button" class="wizard-btn wizard-btn-secondary" (click)="previous()"
          [disabled]="currentStep === 0" *ngIf="!dato_evaluar || !dato_evaluado || dato_evaluar === dato_evaluado">

          <i class="fa-solid fa-arrow-left"></i>

          <span>
            Anterior
          </span>

        </button>


        <div class="footer-spacer"></div>


        <!-- SIGUIENTE -->
        <button type="button" class="wizard-btn wizard-btn-primary" (click)="next()" [disabled]="loading.loading()"
          *ngIf="!(currentStep === steps - 1)" data-tour="firma-next">

          <span>
            Siguiente
          </span>

          <i class="fa-solid fa-arrow-right"></i>

        </button>


        <!-- FINALIZAR -->
        <button type="button" class="wizard-btn wizard-btn-primary" (click)="finalizar()"
          *ngIf="btnFinalizar && (currentStep === steps - 1)">

          <span>
            Finalizar
          </span>

          <i class="fa-solid fa-check"></i>

        </button>

      </div>

    </div>


    <!-- ============================= -->
    <!-- LOADING -->
    <!-- ============================= -->

    <div *ngIf="IsLoading" class="loading-overlay">

      <div class="loading-content">

        <div class="loading-spinner"></div>

        <div class="loading-text">

          <strong>
            Cargando
          </strong>

          <span>
            Estamos preparando la información...
          </span>

        </div>

      </div>

    </div>

  </div>

</div>